import { Typography as MUITypography, TypographyProps } from '@mui/material';

export const Typography = ({ children, ...props }: TypographyProps) => (
  <MUITypography fontFamily="Roboto" color="#000000DE" {...props}>
    {children}
  </MUITypography>
);
